import React from 'react';
import { motion } from 'framer-motion';
import { useInView } from 'framer-motion';
import { useRef } from 'react';

const SectionWrapper = ({ 
  children, 
  delay = 0, 
  className = '', 
  direction = 'up' // 'up', 'left', 'right', 'down'
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-100px" });

  // Define initial positions based on direction
  const getInitialPosition = () => {
    switch (direction) {
      case 'left':
        return { opacity: 0, x: -80, y: 0 };
      case 'right':
        return { opacity: 0, x: 80, y: 0 };
      case 'down':
        return { opacity: 0, x: 0, y: -50 };
      case 'up':
      default:
        return { opacity: 0, x: 0, y: 50 };
    }
  };

  const animatePosition = { opacity: 1, x: 0, y: 0 };

  return (
    <motion.section
      ref={ref}
      initial={getInitialPosition()}
      animate={isInView ? animatePosition : getInitialPosition()}
      transition={{ 
        duration: 0.4, 
        delay,
        ease: [0.25, 0.46, 0.45, 0.94] // Smooth easing
      }}
      style={{ paddingTop: '0', paddingBottom: '0' }}
      className={className}
    >
      {children}
    </motion.section>
  );
};

export default SectionWrapper;